<ng-container>
  <div #chart class="chart" [ngClass]="{'defaultChart':defaultChart, 'chart': !defaultChart}"></div>
</ng-container>
